/* BUDDY AVANZA — Página de pago exitoso
 *
 * IMPORTANTE (arquitectura B2C Fix #2):
 * Esta página NO provisiona ni valida nada por sí sola. El webhook N1CO
 * → backend `POST /api/webhooks/n1co-b2c` sigue siendo la única fuente
 * de verdad para procesar el pago, crear la cuenta y enviar el correo
 * de onboarding.
 *
 * Aquí solo comunicamos al usuario:
 *   • Su pago está siendo confirmado.
 *   • El acceso llegará por correo tras la confirmación asíncrona.
 *   • Pueden pasar unos segundos.
 *
 * Query params: ?intent=<checkout_intent_id>  (informativo)
 */
import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2, Mail, ShieldCheck } from "lucide-react";

export default function AvanzoPagoExitoso() {
  const [params] = useSearchParams();
  const intent = params.get("intent") || "";

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-indigo-50 flex items-center justify-center px-4"
      data-testid="avanzo-pago-exitoso-page"
    >
      <Card className="max-w-lg w-full shadow-xl">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 mx-auto rounded-full bg-emerald-100 flex items-center justify-center mb-4">
            <ShieldCheck className="w-8 h-8 text-emerald-600" />
          </div>
          <h1
            className="text-2xl font-bold text-slate-900"
            data-testid="pago-exitoso-title"
          >
            Confirmando tu pago
          </h1>
          <p className="text-slate-600 mt-3" data-testid="pago-exitoso-copy">
            Estamos procesando tu pago con nuestro procesador. Cuando la
            confirmación esté lista, te enviaremos por correo el acceso
            del estudiante.
          </p>
          <div className="mt-6 bg-slate-50 border border-slate-200 rounded-xl p-4 text-left">
            <div className="flex items-center gap-2 text-slate-700">
              <Mail className="w-5 h-5 text-indigo-600" />
              <span className="text-sm font-medium">
                Revisa tu bandeja de entrada
              </span>
            </div>
            <p className="text-xs text-slate-500 mt-2">
              El correo incluye instrucciones para crear tu contraseña y
              activar BUDDY AVANZA. Si no lo ves en unos minutos, revisa
              la carpeta de spam.
            </p>
          </div>
          <div className="mt-6 flex items-center justify-center gap-2 text-slate-400 text-xs">
            <Loader2 className="w-4 h-4 animate-spin" />
            <span>Esto puede tomar unos segundos…</span>
          </div>
          {intent ? (
            <p
              className="text-[11px] text-slate-400 mt-4 font-mono"
              data-testid="pago-exitoso-intent"
            >
              Ref: {intent}
            </p>
          ) : null}
          <div className="mt-6">
            <Link
              to="/buddy-avanza"
              className="text-indigo-600 hover:text-indigo-800 text-sm underline"
              data-testid="pago-exitoso-back-link"
            >
              Volver a BUDDY AVANZA
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
